module.exports = "<!--\r\nAdd your custom code here.\r\nThis file and any changes you make to it are preserved every time the app is generated.\r\n-->\r\n<button class=\"k-button k-primary forgot-password-button\" type=\"button\">Forgot the password?</button>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/login/bottomSection.html
// module id = ../../../../../src/app/modules/application/login/bottomSection.html
// module chunks = main